<template>
	<div class="contact">
		<div class="title-box">
			<img src="@/assets/images/title_contact.png"/>
		</div>
		<div class="main">
			<div class="in">
				<img class="title" src="@/assets/images/title_contact_1.png"/>
				<p class="label">公众号</p>
				<p class="text">鹿优选商城</p>
				<p class="label">官方邮箱</p>
				<p class="text" style="margin-bottom: 100px;">kf@luyouxuan.com</p>
				<img class="tel" src="@/assets/images/tel.png"/>
			</div>
			
			<img class="pic" src="@/assets/images/pic_contact.png"/>
			<div class="bg"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {},

	}
</script>

<style scoped lang="less">
	.contact{
		padding-top: 130px;
		background: #FBFBFB;
	}
	.title-box{
		margin-bottom: 80px;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: 84px;
		}
	}
	.main{
		position: relative;
		z-index: 3;
		
		.in{
			width: 1180px;
			margin: 0 auto;
			padding-bottom: 223px;
		}
		.title{
			width: auto;
			height: 99px;
			margin-bottom: 80px;
		}
		.label{
			color: #6E6E6E;
			font-size: 18px;
			margin-bottom: 4px;
		}
		.text{
			color: #1E1E1E;
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 40px;
		}
		.tel{
			width: auto;
			height: 74px;
		}
	}
	.pic{
		position: absolute;
		z-index: 2;
		right: 0;
		bottom: 0;
		width: 80%;
		max-width: 1100px;
		height: auto;
	}
	.bg{
		position: absolute;
		z-index: 1;
		right: 0;
		bottom: 0;
		top: -1000px;
		width: 30%;
		max-width: 500px;
		background: #FF4F6A;
	}
</style>